import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=d927b61c&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=d927b61c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d927b61c",
  null
  
)

export default component.exports